import React from 'react';
import {connect} from 'react-redux';

import Meta               from 'app/components/common/meta';
import Form               from 'app/components/forms/form';
import MainLayout         from 'app/components/layout/main-layout';
import PageLoading        from 'app/components/layout/page-loading';

import ProgramAppForm from 'app/components/grant-system/program-app-form';
import GrantSysDuck from 'app/ducks/grants-system';


class PageGrantApply extends React.PureComponent {

  constructor(props) {
    super(props);
  }

  render() {
    const {program} = this.props;
    const title = program?.title || 'Apply';

    return (
      <MainLayout className="page-form">
        <Meta title={`${title} | Millie`} />
        {!!program && <ProgramAppForm program={program} />}
      </MainLayout>
    );
  }

}

const stateToProps = (state) => ({
  program: GrantSysDuck.Slx.pathProgram(state),
});
const dispatchToProps = (dispatch) => ({});

export default connect(stateToProps, dispatchToProps)(PageGrantApply);
